import { jsPDF } from "jspdf";

export default function generateGroupListReport(data, selectedDate = null) {
  const doc = new jsPDF('portrait');

  let yPos = 10; // Set initial Y position

  // Use the selected date if provided, otherwise try to extract from data, otherwise use current date
  let formattedDate;
  if (selectedDate) {
    formattedDate = selectedDate;
  } else {
    let latestReportDate = null;
    data.forEach(helicopter => {
      if (helicopter.reportDate) {
        const currentDate = new Date(helicopter.reportDate);
        if (!latestReportDate || currentDate > latestReportDate) {
          latestReportDate = currentDate;
        }
      }
    });
    formattedDate = latestReportDate ? latestReportDate.toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
  }

  // Column definitions for consistent layout (defined early to avoid hoisting issues)
  const columns = [
    { header: "Last Name", width: 45, key: 'lastName' },
    { header: "First Name", width: 45, key: 'firstName' },
    { header: "Weight", width: 25, key: 'weight' },
    { header: "Beacon #", width: 25, key: 'beaconNumber' },
    { header: "Allergies", width: 25, key: 'hasAllergies' },
    { header: "Medical", width: 25, key: 'hasMedical' },
  ];

  // Function to wrap text within a column width (defined early to avoid hoisting issues)
  const wrapText = (doc, text, maxWidth) => {
    if (!text) return [''];

    const words = text.toString().split(' ');
    const lines = [];
    let currentLine = '';

    words.forEach(word => {
      const testLine = currentLine ? `${currentLine} ${word}` : word;
      const textWidth = doc.getTextWidth(testLine);

      if (textWidth <= maxWidth - 4) { // Leave 4 units padding
        currentLine = testLine;
      } else {
        if (currentLine) {
          lines.push(currentLine);
          currentLine = word;
        } else {
          // Single word is too long, truncate it
          lines.push(word.substring(0, Math.floor(word.length * maxWidth / textWidth)));
        }
      }
    });

    if (currentLine) {
      lines.push(currentLine);
    }

    return lines.length > 0 ? lines : [''];
  };

  // Function to draw text in a cell with proper boundaries (defined early to avoid hoisting issues)
  const drawCellText = (doc, text, x, y, width, height) => {
    const lines = wrapText(doc, text, width);
    const lineHeight = 2.5;

    // Draw each line of text
    lines.forEach((line, index) => {
      if (index * lineHeight < height - 1.5) { // Make sure text fits in cell height
        doc.text(line, x + 2, y + 2.5 + (index * lineHeight));
      }
    });

    return lines.length * lineHeight;
  };

  doc.setFontSize(16);
  doc.text(`Group List Report ${formattedDate}`, 100, yPos, { align: "center" });
  yPos += 8; // Adjust position after the title

// Commenting Coverpage code, do not need on the report for now
/*
  // Adding a cover page 
  const addCoverPage = (doc, helicopterIds, groupIds, totalClient, reportDate,helicoptersData)  => {
    doc.setFontSize(20);
    doc.text("Client Group List", 10, 20);
    doc.setFontSize(16);
    doc.text(`Eagle Pass Heli`, 10, 30);
    doc.text(`Date: ${reportDate}`, 10, 40);


    
    const summaries = [
      {
        title: 'Heli Breakdown',
        details: `Helicopters: ${helicopterIds.join(', ')}`
      },
      {
        title: 'Groups',
        details: `Group IDs: ${groupIds.join(', ')}`
      },
      {
        title: 'Total Clients',
        details: `Total Clients: ${totalClients}`
      }
    ];
    console.log(helicoptersData);
    console.log(groupIds);
    // Drawing the headers for main page table 
    let y = 60;

//build table here
const drawMainHeaders = (doc, y) => {
  doc.setFontSize(12);
  doc.setFont('helvetica','bold');
  const Mainheaders = [
    { mainheader: 'Heli', width: 50 },
    { mainheader: 'Group', width: 50 }
  ];

  let x = 10;
  Mainheaders.forEach(mainhead => {
    doc.setDrawColor(0);
    doc.setFillColor(211, 211, 211);
    doc.rect(x, y, mainhead.width, 10, 'FD');
    doc.text(mainhead.mainheader, x + 5, y + 7);
    x += mainhead.width;
  });
  doc.setFont('helvetica','normal');
  return y + 10;
};
    y = drawMainHeaders(doc, y);
    y += 5;
    doc.setFontSize(10);
helicoptersData.forEach(heliObj => {
  heliObj.groups.forEach(groupObj => {
    let x =15;
    let rectWidth = 50; // Width of each column
    let rectHeight = 10; // Height of each row
     // Draw rectangle for 'Heli' column
     doc.setDrawColor(0);
     doc.setFillColor(255, 255, 255); // White fill for 'Heli' column
     doc.rect(x-5, y-5, rectWidth, rectHeight, 'FD');
    doc.text(`Heli #${heliObj.heliIndex}`, x, y);
    x+=rectWidth; // Width of each column
    doc.setDrawColor(0);
    doc.setFillColor(255, 255, 255); // White fill for 'Group' column
    doc.rect(x-5, y-5, rectWidth, rectHeight, 'FD');
    doc.text(`Group #${groupObj.groupIndex}`, x, y);
    y += rectHeight ;
  });
});
y+=10;



    summaries.forEach(summary => {
      doc.setFontSize(12);
      doc.text(summary.title, 10, y);
      doc.setFontSize(10);
      doc.text(summary.details, 10, y + 10);
      y += 30;
    });

    doc.addPage(); // Add a new page for the detailed reports
  };
*/

  // Function to draw table headers using the column system
  const drawHeaders = (doc, y) => {
    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');

    let x = 10;
    columns.forEach(col => {
      doc.setDrawColor(0);
      doc.setFillColor(211, 211, 211);
      doc.rect(x, y, col.width, 6, 'FD');
      doc.setTextColor(0, 0, 0);
      doc.text(col.header, x + 2, y + 4);
      x += col.width;
    });

    doc.setFont('helvetica', 'normal');
    return y + 6;
  };

  // Function to draw page header
  const drawPageHeader = (doc, helicopter, formattedDate) => {
    doc.setFontSize(16);
    doc.setTextColor(0, 0, 0);
    doc.text(`Group List Report ${formattedDate}`, 100, 10, { align: "center" });

    doc.setFontSize(12);
    doc.setTextColor(255, 0, 0); // Red color for Heli #
    doc.text(`Heli #${helicopter.heliIndex}`, 10, 22);
    doc.setTextColor(0, 0, 0); // Black color
    doc.text(` - ${helicopter.helicopterId}`, 25, 22);
    doc.text(`Pilot: ${helicopter.pilot}`, 10, 27);

    return 35; // Return Y position after header
  };

  // Function to render a person (guide or client) using the column system
  const renderPerson = (doc, person, y, isGuide = false, isAdditionalGuide = false) => {
    doc.setFontSize(8);

    // Calculate the row height needed based on text wrapping
    let maxRowHeight = 5; // Minimum row height

    // First pass: calculate required height for this row
    columns.forEach(col => {
      let cellText = '';
      if (col.key === 'lastName') {
        cellText = person.lastName || person.guideLastName || person.guideAdditionalLastName || 'N/A';
      } else if (col.key === 'firstName') {
        cellText = person.firstName || person.guideFirstName || person.guideAdditionalFirstName || 'N/A';
      } else if (col.key === 'weight') {
        cellText = person.weight || person.guideWeight || person.guideAdditionalWeight || 'N/A';
      } else if (col.key === 'beaconNumber') {
        cellText = person.beaconNumber || person.guideBeaconNumber || person.guideAdditionalBeaconNumber || 'N/A';
      } else if (col.key === 'hasAllergies') {
        if (isGuide || isAdditionalGuide) {
          cellText = 'N/A'; // Guides don't have allergy info in this report
        } else {
          cellText = person.hasAllergies ? 'YES' : 'NO';
        }
      } else if (col.key === 'hasMedical') {
        if (isGuide || isAdditionalGuide) {
          cellText = 'N/A'; // Guides don't have medical info in this report
        } else {
          cellText = person.hasMedical ? 'YES' : 'NO';
        }
      }

      const lines = wrapText(doc, cellText, col.width);
      const requiredHeight = Math.max(5, lines.length * 2.5 + 1.5);
      maxRowHeight = Math.max(maxRowHeight, requiredHeight);
    });

    // No page break check needed - handled at group level

    // Draw cell borders and content
    let x = 10;
    columns.forEach(col => {
      // Draw cell border
      doc.setDrawColor(0);
      doc.setFillColor(255, 255, 255);
      doc.rect(x, y, col.width, maxRowHeight, 'FD');

      // Get cell content and set appropriate color
      let cellText = '';
      let textColor = [0, 0, 0]; // Default black

      if (col.key === 'lastName') {
        if (isGuide) {
          cellText = person.guideLastName || 'N/A';
        } else if (isAdditionalGuide) {
          cellText = person.guideAdditionalLastName || 'N/A';
        } else {
          cellText = person.lastName || 'N/A';
        }
        if (isGuide || isAdditionalGuide) {
          textColor = [89, 103, 135]; // Blue for guides
        }
      } else if (col.key === 'firstName') {
        if (isGuide) {
          cellText = person.guideFirstName || 'N/A';
        } else if (isAdditionalGuide) {
          cellText = person.guideAdditionalFirstName || 'N/A';
        } else {
          cellText = person.firstName || 'N/A';
        }
        if (isGuide || isAdditionalGuide) {
          textColor = [255, 0, 0]; // Red for guide first names
        }
      } else if (col.key === 'weight') {
        if (isGuide) {
          cellText = person.guideWeight || 'N/A';
        } else if (isAdditionalGuide) {
          cellText = person.guideAdditionalWeight || 'N/A';
        } else {
          cellText = person.weight || 'N/A';
        }
        if (isGuide || isAdditionalGuide) {
          textColor = [89, 103, 135]; // Blue for guides
        }
      } else if (col.key === 'beaconNumber') {
        if (isGuide) {
          cellText = person.guideBeaconNumber || 'N/A';
        } else if (isAdditionalGuide) {
          cellText = person.guideAdditionalBeaconNumber || 'N/A';
        } else {
          cellText = person.beaconNumber || 'N/A';
        }
        if (isGuide || isAdditionalGuide) {
          textColor = [89, 103, 135]; // Blue for guides
        }
      } else if (col.key === 'hasAllergies') {
        if (isGuide || isAdditionalGuide) {
          cellText = 'N/A';
          textColor = [89, 103, 135]; // Blue for guides
        } else {
          cellText = person.hasAllergies ? 'YES' : 'NO';
          textColor = person.hasAllergies ? [255, 0, 0] : [0, 0, 0]; // Red for allergies, black for no allergies
        }
      } else if (col.key === 'hasMedical') {
        if (isGuide || isAdditionalGuide) {
          cellText = 'N/A';
          textColor = [89, 103, 135]; // Blue for guides
        } else {
          cellText = person.hasMedical ? 'YES' : 'NO';
          textColor = person.hasMedical ? [255, 0, 0] : [0, 0, 0]; // Red for medical, black for no medical
        }
      }

      // Set text color
      doc.setTextColor(textColor[0], textColor[1], textColor[2]);

      // Draw cell content
      drawCellText(doc, cellText, x, y, col.width, maxRowHeight);

      x += col.width;
    });

    // Reset text color
    doc.setTextColor(0, 0, 0);
    return y + maxRowHeight;
  };

  let helicoptersData = [];

  data.forEach(helicopter => {
      let heliObj = {
          heliIndex: helicopter.heliIndex,
          groups: []
      };
      helicopter.groups.forEach(group => {
          let groupObj = {
              groupIndex: group.groupIndex
          };
          heliObj.groups.push(groupObj);
      });
  
      helicoptersData.push(heliObj);
  });

  data.forEach((helicopter, index) => {
    if (index > 0) {
      doc.addPage();
    }

    let y = drawPageHeader(doc, helicopter, formattedDate);

    helicopter.groups.forEach(group => {
      // Calculate total height needed for this entire group
      let groupHeaderHeight = 5; // Group header (reduced from 7)
      let tableHeaderHeight = 6; // Table headers (reduced from 8)
      let spacingAfterHeaders = 1; // Reduced from 2
      let clientRowsHeight = 0;
      let fuelPercentageHeight = 10; // Fuel percentage line + spacing (reduced from 15)

      // Calculate height for primary guide if exists
      if (group.guideFirstName && group.guideLastName !== "No guide") {
        clientRowsHeight += 5; // Minimum row height for guide (reduced from 6)
      }

      // Calculate height for additional guide if exists
      if (group.guideAdditionalFirstName && group.guideAdditionalLastName !== "No additional guide") {
        clientRowsHeight += 5; // Minimum row height for additional guide (reduced from 6)
      }

      // Calculate height for all clients
      group.clients.forEach(() => {
        clientRowsHeight += 5; // Minimum row height per client (reduced from 6)
      });

      const totalGroupHeight = groupHeaderHeight + tableHeaderHeight + spacingAfterHeaders + clientRowsHeight + fuelPercentageHeight;

      // Check if entire group fits on current page, if not start new page
      if (y + totalGroupHeight > 280) {
        doc.addPage();
        y = drawPageHeader(doc, helicopter, formattedDate);
      }

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.text(`Group #${group.groupIndex} (H${helicopter.heliIndex}G${group.groupIndex})`, 10, y);
      y += 5;

      y = drawHeaders(doc, y);
      y += 1;

      // Render primary guide if exists (no page break check needed - handled at group level)
      if (group.guideFirstName && group.guideLastName !== "No guide") {
        y = renderPerson(doc, group, y, true, false);
      }

      // Render additional guide if exists (no page break check needed - handled at group level)
      if (group.guideAdditionalFirstName && group.guideAdditionalLastName !== "No additional guide") {
        y = renderPerson(doc, group, y, false, true);
      }

      // Render all clients (no page break check needed - handled at group level)
      group.clients.forEach(client => {
        y = renderPerson(doc, client, y, false, false);
      });

      // Add fuel percentage with proper spacing
      y += 3; // Add some space before fuel percentage (reduced from 5)
      if (y + 7 > 280) {
        doc.addPage();
        y = drawPageHeader(doc, helicopter, formattedDate);
      }

      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text(`Fuel Percentage: `, 10, y);
      doc.setTextColor(255, 0, 0); // Red for fuel percentage
      doc.text(`${group.fuelPercentage}%`, 35, y);
      doc.setTextColor(0, 0, 0); // Reset to black
      y += 10; // Spacing between groups (reduced from 15)
    });
  });

  doc.save(`group-list-report-${formattedDate}.pdf`);
}